import React, { useState, useEffect, useContext } from "react";
import { TbFilterDown, TbFilterUp } from "react-icons/tb";
import Search from "../Searchbar/Search";
import { Link } from "react-router-dom";
import { fetchCompCountData } from "../Searchbar/KpiSearch";
import { FilterContext } from "../../context/Filter";

const Header = ({ onReset }) => {
  const [workshopComplaints, setWorkshopComplaints] = useState(0);
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [enRouteBreakdownComplaints, setEnRouteBreakdownComplaints] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const {
    searchData,
    setSearchData,
    setComplaintButtonName,
    isToggle,
    setSelectedSearchType,
    selectedSearchType,
  } = useContext(FilterContext);

  const fetchData = async (searchData) => {
    try {
      const data = await fetchCompCountData(searchData);
      if (data) {
        setTotalComplaints(
          data.cac_count.doc_count + data.csr_count.doc_count || 0
        );
        setWorkshopComplaints(data.cac_count.doc_count || 0);
        setEnRouteBreakdownComplaints(data.csr_count.doc_count || 0);
      }
    } catch (error) {
      console.error("Error fetching complaint data:", error);
    }
  };

  useEffect(() => {
    fetchData(searchData);
  }, [isToggle]);

  return (
    <div>
      {isVisible && (
        <div className="flex items-center gap-2 justify-center">
          <Search
            setSelectedSearchType={setSelectedSearchType}
            selectedSearchType={selectedSearchType}
            searchData={searchData}
            setSearchData={setSearchData}
          />

          <button
            onClick={onReset}
            className="px-3 py-1 mt-2 bg-gray-200 hover:bg-gray-300 rounded-md text-gray-700 border border-gray-300 shadow-sm"
          >
            Reset
          </button>
        </div>
      )}

      <div className="text-sm flex gap-2 items-center w-full justify-center mt-6">
        <button
          onClick={() => setComplaintButtonName("totalComplaints")}
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] text-white p-2 rounded-lg w-full max-w-48"
        >
          Total Complaints - {totalComplaints}
        </button>

        <button
          onClick={() => setComplaintButtonName("workshopComplaints")}
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] text-white p-2 rounded-lg w-full max-w-52"
        >
          Workshop Complaints - {workshopComplaints}
        </button>

        <Link
          to="#"
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] text-white p-2 rounded-lg w-full max-w-72"
        >
          <button
            onClick={() =>
              setComplaintButtonName("enRouteBreakdownComplaints")
            }
          >
            En-Route Breakdown Complaints - {enRouteBreakdownComplaints}
          </button>
        </Link>

        <div
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] text-white p-2 rounded-lg cursor-pointer"
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? <TbFilterUp size={22} /> : <TbFilterDown size={22} />}
        </div>
      </div>
    </div>
  );
};

export default Header;
